module.exports = __webpack_public_path__ + "media/video1.3d001ebd.mp4";